import { Box } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


import { useLocalStorage } from "../../../hooks";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";



import { TwContainer, TwMainLayout } from "../../../components/tailwind";
import { userState } from "../../../redux/reducers/userReducer";
import PurchasedSessionPass from "./PurchasedSessionPass";
import SessionPassBooking from "./SessionPassBooking";

export default function SessionPassDetail({ navigation, profileFor, title }) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const anchorEl = React.useRef(null);
  const [loading, setLoading] = React.useState(false);
  const [classInfo, setClassInfo] = React.useState({});
  const [selectCustomerBooking, setSelectCustomerBooking] = React.useState([]);
  const [selectBuyingDetail, setSelectBuyingDetail] = React.useState({});
  const [passPurchaseList, setPassPurchaseList] = React.useState({ data: [], total: 0 });

  React.useEffect(() => {
    (async () => {
      console.log("dashboardReduxState.sessionPassData", dashboardReduxState.sessionPassData);
      setClassInfo(dashboardReduxState.sessionPassData)
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken, dashboardReduxState.sessionPassData]);


  const onBackClick = () => {
    if (selectCustomerBooking.length) {
      setSelectCustomerBooking([])
      setSelectBuyingDetail({})
    } else {
      navigate("/myclasses/detail", { replace: true });
    }
  };

  return (
    <TwMainLayout
      headTitle={title}
      breadcrumbs={[
        { title: "My Classes", onClick: () => { navigation("/myclasses"); } },
        { title: classInfo.className, onClick: () => { onBackClick(); } },
        { title: `${classInfo?.selectedPassDetail?.passName}` },
      ]}
      children={
        <TwContainer className="flex flex-col w-full">
          <div className={"flex w-full gap-4"}>
            <h2 className={"font-bold text-2xl sm:text-3xl text-brown-coffee"}>
              {classInfo?.selectedPassDetail?.passName}
            </h2>
          </div>
          <div className="grid grid-cols-1 w-full py-2 gap-2 ">
            <div className="p-4 pt-3 pb-8 border-2 border-bright-gray /*hover:border-indigo-bz*/ rounded-lg bg-[#f4f4f4]">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
                {/* <div className="mt-0">
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    Pass Name
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>{classInfo?.selectedPassDetail?.passName}</span>
                  </p>
                </div> */}
                <div>
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    No Of Sessions
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>{classInfo?.selectedPassDetail?.noOfAllowedSessions}</span>
                  </p>
                </div>
                <div>
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    Price
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>€{classInfo?.selectedPassDetail?.amount}</span>
                  </p>
                </div>
                <div>
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    Validity
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>{classInfo?.selectedPassDetail?.validUntilConsumed === true ? "Until Consumed" : classInfo?.selectedPassDetail?.validityDays}</span>
                  </p>
                  <p className={"font-light text-sm text-[#B5B5C3]"}>
                    From the purchase date
                  </p>
                </div>
                <div>
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    Passes Sold
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>{passPurchaseList?.total || 0}</span>
                  </p>
                </div>

              </div>
            </div>
            {/* <div className={"flex flex-col gap-4"}>
              <div className="mt-10 p-4 pt-5 pb-10 border-2 border-bright-gray hover:border-indigo-bz rounded-lg grid grid-cols-2 gap-6">
                <div className="mt-5">
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    Pass Name
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>{classInfo?.selectedPassDetail?.passName}</span>
                  </p>
                </div>
                <div>
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    Sessions Capacity
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>{classInfo?.selectedPassDetail?.noOfAllowedSessions}</span>
                  </p>
                </div>
                <div>
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    Price
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>€{classInfo?.selectedPassDetail?.amount}</span>
                  </p>
                </div>
                <div>
                  <h4 className={"font-bold text-lg text-brown-coffee"}>
                    Validity Days
                  </h4>
                  <p className={"font-light text-base"}>
                    <span>{classInfo?.selectedPassDetail?.validUntilConsumed === true ? "Until Consumed" : classInfo?.selectedPassDetail?.validityDays}</span>
                  </p>
                </div>

              </div>
            </div> */}
          </div>
          {selectCustomerBooking.length ? (<SessionPassBooking
            navigation={navigation}
            loading={setLoading}
            setLoading={setLoading}
            classInfo={classInfo}
            selectCustomerBooking={selectCustomerBooking}
            selectBuyingDetail={selectBuyingDetail}
          />) : (<PurchasedSessionPass
            classInfo={classInfo}
            selectBuyingDetail={setSelectBuyingDetail}
            setPassPurchaseList={setPassPurchaseList}
          />)}
        </TwContainer>
      } />
  );
}
